import React from 'react';

const PageContainer = ({tipologia, className, children})=> {
    return <div className={`${tipologia.CLASSNAME} ${className}`} style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', overflowY: 'scroll' }}>
        {children}
    </div>    
}

export default PageContainer;